import tuneInRequest from '../tuneInRequest';
import isServer from '../utils/isServer';
export default function metricsService(config, apiContext, applyReauth) {
    const metricsEndpoint = `${config.domains.local}/metrics`;
    const loopback = `${config.domains.loopback}${metricsEndpoint}`;
    const loopbackOrProxyEndpoint = isServer() ? loopback : metricsEndpoint;
    function getMetricsAuthorization() {
        return tuneInRequest({
            method: 'get',
            url: `${loopbackOrProxyEndpoint}/authorization/`,
            disableRetry: true,
        }, apiContext);
    }
    return {
        getMetricsAuthorization: applyReauth(getMetricsAuthorization),
    };
}
